// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2b4uz","range":"MonthRangeSwitch_range__3x9Xp","disabled":"MonthRangeSwitch_disabled__3grRJ"};